<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <v-row v-if="!loading">
      <v-col cols="12" md="5">
        <chart-gauti-menuo :chart="chartGautiMenuo" :laikotarpis="menuo" />
      </v-col>
      <v-col cols="12" md="7">
        <chart-gauti-metai :chart="chartGautiMetai" :laikotarpis="metai" />
      </v-col>
      <v-col cols="12" md="5">
        <chart-veiksmai-menuo
          :chart="chartVeiksmaiMenuo"
          :laikotarpis="menuo"
        />
      </v-col>
      <v-col cols="12" md="7">
        <chart-veiksmai-metai
          :chart="chartVeiksmaiMetai"
          :laikotarpis="metai"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChartGautiMenuo from './chart/ChartGautiMenuo'
import ChartGautiMetai from './chart/ChartGautiMetai'
import ChartVeiksmaiMenuo from './chart/ChartVeiksmaiMenuo'
import ChartVeiksmaiMetai from './chart/ChartVeiksmaiMetai'

export default {
  name: 'DashboardStatistika',
  components: {
    ChartGautiMenuo,
    ChartGautiMetai,
    ChartVeiksmaiMenuo,
    ChartVeiksmaiMetai,
  },
  data() {
    return {
      pageloading: true,
      loading: true,

      menuo: '',
      metai: '',
      chartGautiMenuo: {},
      chartGautiMetai: [],
      chartVeiksmaiMenuo: [],
      chartVeiksmaiMetai: [],
    }
  },
  computed: {
    //
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true

      this.$axios
        .get(`pagrindinis/statistika`)
        .then(res => {
          this.menuo = res.data.menuo
          this.metai = res.data.metai
          this.chartGautiMenuo = res.data.gauti_menuo
          this.chartGautiMetai = res.data.gauti_metai
          this.chartVeiksmaiMenuo = res.data.veiksmai_menuo
          this.chartVeiksmaiMetai = res.data.veiksmai_metai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
  },
}
</script>
